// General
import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';

// Styles
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ItineraryContainer.css';

// Component 
import Itinerary from '../../components/Itinerary';
import Loader from '../../components/Loader';
import { withQuery } from '../../hoc/withGraphql';

// Graphql
import getItineraryQuery from './getItineraryQuery.graphql';

class ItineraryContainer extends React.Component {
  static propTypes = {
    reservationId: PropTypes.number.isRequired,
    itineraryData: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      getItinerary: PropTypes.object.isRequired
    })
  };

  static defaultProps = {
    itineraryData: {
      loading: true,
    }
  };

  render() {
    const { itineraryData: { loading, getItinerary } } = this.props;

    if (loading) {
      return (
        <div>
          <Loader type={"text"} show={loading} loaderClass={'textLoader'} />
        </div>
      );
    }

    return (
      <div className='layoutPaddingTopMobile'>
        <Itinerary data={getItinerary} />
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  withQuery(getItineraryQuery,
    {
      name: 'itineraryData',
      options: (props) => ({
        variables: {
          reservationId: props.reservationId,
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
)(ItineraryContainer);
